import { GlobalOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { useLocale } from "../../i18n/useLocale";
import { SUPPORTED_LOCALES, LOCALE_LABELS } from "../../i18n";
import type { SupportedLocale } from "../../i18n/detectLanguage";

interface LanguageSwitcherProps {
  variant?: "default" | "compact";
}

export const LanguageSwitcher = ({
  variant = "default",
}: LanguageSwitcherProps) => {
  const { locale, setLocale } = useLocale();

  const items: MenuProps["items"] = SUPPORTED_LOCALES.map((code) => ({
    key: code,
    label: LOCALE_LABELS[code],
  }));

  const onClick: MenuProps["onClick"] = ({ key }) => {
    void setLocale(key as SupportedLocale);
  };

  const label = LOCALE_LABELS[locale];

  return (
    <Dropdown
      menu={{ items, onClick, selectedKeys: [locale] }}
      placement="bottomRight"
      trigger={["click"]}
    >
      <Button
        type="text"
        size={variant === "compact" ? "small" : "middle"}
        icon={<GlobalOutlined />}
        aria-label={label}
      >
        {variant === "compact" ? null : label}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
